import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isFuture } from 'date-fns';

import { EndedSaleDetails } from './EndedSaleDetails/index.tsx';
import { LiveSaleDetails } from './LiveSaleDetails/index.tsx';
import type {
  SaleDetails_anyCard,
  SaleDetails_offer,
} from './__generated__/index.graphql.ts';

type Props = {
  sale: SaleDetails_offer;
  card: SaleDetails_anyCard;
  isDesktopLayout?: boolean;
  stackedTokensCount?: number;
  showFees?: boolean;
  onSuccess?: () => void;
};

export const SaleDetails = ({ sale, card, ...rest }: Props) => {
  const isLive = sale?.endDate ? isFuture(sale.endDate) : true;

  if (isLive) {
    return <LiveSaleDetails sale={sale} card={card} {...rest} />;
  }

  return <EndedSaleDetails sale={sale} card={card} />;
};

SaleDetails.fragments = {
  anyCard: gql`
    fragment SaleDetails_anyCard on AnyCardInterface {
      slug
      ...EndedSaleDetails_anyCard
      ...LiveSaleDetails_anyCard
    }
    ${LiveSaleDetails.fragments.anyCard}
    ${EndedSaleDetails.fragments.anyCard}
  ` as TypedDocumentNode<SaleDetails_anyCard>,
  offer: gql`
    fragment SaleDetails_offer on TokenOffer {
      id
      endDate
      ...LiveSaleDetails_offer
      ...EndedSaleDetails_offer
    }
    ${LiveSaleDetails.fragments.offer}
    ${EndedSaleDetails.fragments.offer}
  ` as TypedDocumentNode<SaleDetails_offer>,
};
